var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.dado?.parcelas),function(parcela){return _c(_setup.LinhaDeParcelas,{key:parcela?.id,attrs:{"dado":_setup.props?.dado,"parcela":parcela},on:{"update:alteraParcela":_setup.alteraParcela,"update:alteraAdiantamento":_setup.alteraAdiantamento}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }